module.exports = __webpack_public_path__ + "img/tick-inside-circle.d321e8c5.svg";